import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./EndClients.css";
import EndClientCard from "../../../components/EndClientCard/EndClientCard";
import EndClientForm from "./EndClientForm";
import RightSideBar from "../../../components/Rightsidebar/RightSideBar";
import Pagination from "../../../components/DynamicTable/Pagination";
import { getEndClientsAsync } from "../../../_redux/_services/ClientsSlice";
import GetJobId from "../../../_utilities/GetJobId";
import { DashboardPlusicon } from "../../../Icons/DashboardPlusicon";

const EndClients = () => {
  const dispatch = useDispatch();
  const clientId = GetJobId();

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [sidebarMode, setSidebarMode] = useState("add"); // 'add' or 'edit'
  const [selectedClient, setSelectedClient] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 6;

  const endClientsData = useSelector((state) => state.GetEndClients.data);
  const endClients = endClientsData?.endClients || [];
  const totalCount = endClientsData?.totalCount || endClients.length; // Fallback to current length if totalCount is missing

  const fetchEndClients = (page) => {
    if (clientId) {
      const offset = (page - 1) * pageSize + 1;
      dispatch(
        getEndClientsAsync(clientId, { limit: pageSize, offset: offset }),
      );
    }
  };

  useEffect(() => {
    fetchEndClients(currentPage);
  }, [dispatch, clientId, currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleAddClick = () => {
    setSidebarMode("add");
    setSelectedClient(null);
    setIsSidebarOpen(true);
  };

  const handleEditClick = (client) => {
    setSidebarMode("edit");
    setSelectedClient(client);
    setIsSidebarOpen(true);
  };

  const handleSidebarClose = (shouldRefresh) => {
    setIsSidebarOpen(false);
    if (shouldRefresh) {
      fetchEndClients(currentPage);
    }
  };

  const sidebarLayout = {
    title: sidebarMode === "add" ? "Add End Client" : "Edit End Client",
    description: "",
  };

  return (
    <div className="end-clients-container">
      <div className="end-clients-header">
        <button className="add-client-btn" onClick={handleAddClick}>
          <DashboardPlusicon width={35} height={35} />
          <span>Add End Client</span>
        </button>
      </div>
      <div className="end-clients-grid">
        {endClients.map((client) => (
          <EndClientCard
            key={client.id}
            client={client}
            onEdit={() => handleEditClick(client)}
          />
        ))}
        {endClients.length === 0 && (
          <div className="detail-card-empty No-end-client">
            <img
              src={process.env.PUBLIC_URL + "/assests/nodata.svg"}
              alt="No data"
            />
            No end clients found.
          </div>
        )}
      </div>

      <div className="pagination-wrapper">
        <Pagination
          currentPage={currentPage}
          totalCount={totalCount}
          pageSize={pageSize}
          onPageChange={handlePageChange}
        />
      </div>

      {isSidebarOpen && (
        <RightSideBar
          componentLayout={sidebarLayout}
          onReceiveProps={() => handleSidebarClose(false)}
          componentData={
            <EndClientForm
              mode={sidebarMode}
              data={selectedClient}
              clientId={clientId}
              onClose={handleSidebarClose}
            />
          }
        />
      )}
    </div>
  );
};

export default EndClients;
